<template>
  <div class="py-4" style="background-color: #fff; width: 100%;">
    <div class="container-fluid px-xl-5">
      <ul class="categorias-home d-flex justify-content-center gap-4 list-unstyled m-0 p-0 flex-wrap">
        <li v-for="categoria in categories" :key="categoria.id" @click="filtrarCategoria(categoria.id)" class="text-center category-ring" style="cursor: pointer; width: 100px;">
          <div class="rounded-circle overflow-hidden mb-2 bg-white" style="width: 85px; height: 85px; margin: 0 auto; border: 1px solid #1a1a1a;">
            <img v-if="categoria.imagen" :src="`${dominio}/img/categorias/${categoria.imagen}`" class="img-fluid object-fit-cover w-100 h-100" />
            <div v-else class="w-100 h-100 d-flex align-items-center justify-content-center bg-light">
                <font-awesome-icon icon="tag" class="fs-2 text-secondary" />
            </div>
          </div>
          <span class="text-dark d-block" style="font-size: 0.8rem; font-weight: 400; line-height: 1.2;">{{ categoria.nombre }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { mapState } from 'vuex'

  export default {
    data() {
      return {
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 20,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        dominio: this.$store.state.dominio
      }
    },
    methods: {
    handleResize() {
      if(window.innerWidth < 580){
        this.swiperOption.slidesPerView = 2
      }else {
        this.swiperOption.slidesPerView = 3
      }
     },
     filtrarCategoria(id) {
       this.$store.dispatch('getProductosCat', id)
       this.$router.push('/tienda/' + id)
     }
    },
    beforeCreate(){
        
    },
    computed: {
      ...mapState(['featuredProducts', 'categories'])
    }
  }
</script>

<style lang="scss" scoped>
  .category-ring {
    transition: transform 0.2s ease, opacity 0.2s ease;
  }
  .category-ring:hover {
    transform: translateY(-5px);
    opacity: 0.9;
  }
  .category-ring .rounded-circle {
    box-shadow: 0 4px 6px rgba(0,0,0,0.05);
    transition: box-shadow 0.2s ease, border-color 0.2s ease;
  }
  .category-ring:hover .rounded-circle {
    box-shadow: 0 6px 12px rgba(0,0,0,0.15);
    border-color: #713083 !important;
  }

  .swiper-container {
    background-color: transparent;
  }
  .swiper-slide {
    background-size: cover;
    background-position: center;
    &.slide{
      height:300px;
    }
    &.slide-1 {
      background-image:url('../assets/img/1.jpg');
    }
    &.slide-2 {
      background-image:url('../assets/img/2.jpg');
    }
    &.slide-3 {
      background-image:url('../assets/img/3.jpg');
    }
    &.slide-4 {
      background-image:url('../assets/img/4.jpg');
    }
    &.slide-5 {
      background-image:url('../assets/img/5.jpg');
    }
  }
</style>